import { getHashedEmail, queueAnalyticsEvent, SeoEvent } from 'lib/gtm'
import type { CustomerTypes } from 'modules/customer'
import { isCustomerAdult } from 'modules/customer'
import { bannersStorage, SeoPromotion } from 'shared/analytics'

interface sliderPromotionProps {
  bannerId?: string
  event: SeoEvent.VIEW_PROMOTION | SeoEvent.SELECT_PROMOTION
  customer: CustomerTypes | undefined
  ecommerce: {
    creative_name?: string
    creative_slot: string
    promotion_id?: string
    promotion_name?: string
  }
}

export const sliderPromotion = ({
  event,
  customer,
  ecommerce,
  bannerId
}: sliderPromotionProps) => {
  if (event === SeoEvent.VIEW_PROMOTION) {

    const existingIds: string[] = bannersStorage.get<string[]>([], [])

    if (typeof bannerId === 'string' && !existingIds.includes(bannerId)) {
      existingIds.push(bannerId)
      bannersStorage.set(existingIds)

      queueAnalyticsEvent({ ecommerce: null })
      const eventData = {
        event: event, //constant
        type: 'ecommerce', //constant
        user_id: customer?.code || undefined, //User ID from crm if logged in, if not we return undefined
        user_adult: isCustomerAdult(customer?.dateOfBirth), //1 if customer have more than 18 years, 0 - if no, if no value we return undefined
        hashed_email: getHashedEmail(customer?.email), //customer email in md5 - if logged in, if not we return undefined
        ecommerce
      }

      queueAnalyticsEvent(eventData)
    }
  } else {
    if (ecommerce.creative_name) {
      SeoPromotion.set({
        creativeName: ecommerce.creative_name,
        promotionId: ecommerce.promotion_id || ''
      })
    }
    queueAnalyticsEvent({ ecommerce: null })
    const eventData = {
      event: event, //constant
      type: 'ecommerce', //constant
      user_id: customer?.code || undefined, //User ID from crm if logged in, if not we return undefined
      user_adult: isCustomerAdult(customer?.dateOfBirth), //1 if customer have more than 18 years, 0 - if no, if no value we return undefined
      hashed_email: getHashedEmail(customer?.email), //customer email in md5 - if logged in, if not we return undefined
      ecommerce
    }

    queueAnalyticsEvent(eventData)
  }
}
